import { render, staticRenderFns } from "./WishlistItem.vue?vue&type=template&id=4deca8a0&scoped=true&"
import script from "./WishlistItem.vue?vue&type=script&lang=js&"
export * from "./WishlistItem.vue?vue&type=script&lang=js&"
import style0 from "./WishlistItem.vue?vue&type=style&index=0&id=4deca8a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4deca8a0",
  null
  
)

export default component.exports